// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class SOAPReqMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_SOAP_REQ, fieldSet);
    }
    getName() {
        return this.getFieldValue(FieldsFactory.FIELD_NAME);
    }
    setName(name) {
        this.setFieldValue(FieldsFactory.FIELD_NAME, name);
    }
}
